import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import {
  BASE_URL,
  getIdIntegration,
  ISICOM_CSS_PATH,
  ISICOM_JS_PATH,
} from 'services/isicom';

function Isicom(): JSX.Element {
  const [isScriptLoaded, setIsScriptLoaded] = useState(false);

  useEffect(() => {
    const script = document.createElement('script');
    script.src = ISICOM_JS_PATH;
    script.async = true;

    document.body.appendChild(script);

    const handleScriptLoad = () => {
      setIsScriptLoaded(true);
    };

    script.addEventListener('load', handleScriptLoad);

    return () => {
      script.removeEventListener('load', handleScriptLoad);
      document.body.removeChild(script);
    };
  }, []);

  useEffect(() => {
    if (isScriptLoaded) {
      const idIntegration = getIdIntegration();
      const script = document.createElement('script');

      script.text = `
    IsicomTab({
      id_integration: ${idIntegration},
      url: '${BASE_URL}',
    })
  `;

      document.body.appendChild(script);

      return () => {
        document.body.removeChild(script);
      };
    }
  }, [isScriptLoaded]);

  return (
    <div>
      <Helmet>
        <link rel="stylesheet" href={ISICOM_CSS_PATH} />
      </Helmet>
    </div>
  );
}

export default Isicom;
